import React, { useMemo } from "react";
import MasterDataFormV2 from "../../MasterDataFormV2";
import { useUser } from "contexts/v1/masterData/UserContext";
import { useSchedulePattern } from "../context/SchedulePatternContext";
import UserSelector from "./UserSelector";
import { formatDateToLocal } from "utils/utils";

const GenerateScheduleFromPatternPage = ({ onSuccess, onError }) => {
  const { users } = useUser();
  const { schedulePatterns } = useSchedulePattern();

  // Create options from hooks data
  const schedulePatternOptions = schedulePatterns.data?.map(pattern => ({
    value: pattern.id,
    label: pattern.name
  })) || [];

  const fields = useMemo(() => [
    {
      name: "schedule_pattern_id",
      label: "Schedule Pattern",
      type: "select",
      required: true,
      options: schedulePatternOptions,
      placeholder: "Select schedule pattern",
    },
    {
      name: "start_date",
      label: "Start Date",
      type: "date",
      required: true,
      defaultValue: formatDateToLocal(new Date()), // Today's date
    },
    {
      name: "end_date",
      label: "End Date",
      type: "date",
      required: true,
      defaultValue: formatDateToLocal(new Date()), // Today's date
    },
    {
      name: "status",
      label: "Status",
      type: "select",
      required: true,
      options: [
        { value: "draft", label: "Draft" },
        { value: "published", label: "Published" },
      ],
      defaultValue: "draft",
    },
    {
      name: "user_ids",
      label: "Select Employees",
      type: "custom",
      required: true,
      render: ({ value, onChange }) => (
        <UserSelector 
          value={value} 
          onChange={onChange} 
          users={users.data || []} 
        />
      )
    },
  ], [users.data, schedulePatternOptions]);

  return (
    <MasterDataFormV2
      apiUrl="/ahr/schedules/generate-from-pattern"
      initialData={null}
      fields={fields}
      onSuccess={onSuccess}
      onError={onError}
      submitButtonText="Generate Schedules"
    />
  );
};

export default GenerateScheduleFromPatternPage;